import { read, writeFileXLSX } from 'xlsx';
import { DataExporter, makeFilename } from '.';

export default function xlsx(exporter: DataExporter) {
  const data = exporter();

  const csv = [
    data.title,
    data.subTitle,
    ...data.tables.map(table =>
      table.title
        ? [table.title, table.header.join(','), ...table.body.map(row => row.map(row => `"${row}"`).join(','))]
        : [table.header.join(','), ...table.body.map(row => row.map(row => `"${row}"`).join(','))]
    )
  ]
    .flat()
    .join('\n');

  const workbook = read(csv, { type: 'binary', raw: true });
  writeFileXLSX(workbook, `${makeFilename(data)}.xlsx`);
}
